import { ActionButtons } from '../components/ActionButtons';
import { Header } from '../components/Header';
import { InputPanel } from '../components/InputPanel';
import { PreparationCards } from '../components/PreparationCards';
import { StatusBanner } from '../components/StatusBanner';
import { usePreparation } from '../hooks/usePreparation';

export const HomePage = () => {
  const {
    customerProfile,
    setCustomerProfile,
    category,
    setCategory,
    market,
    setMarket,
    clientType,
    setClientType,
    scenario,
    setScenario,
    result,
    loading,
    error,
    notice,
    generate,
    clear,
    exportPdf,
    canExport
  } = usePreparation();

  return (
    <main className="page-shell">
      <div className="page-shell__bg page-shell__bg--top" />
      <div className="page-shell__bg page-shell__bg--bottom" />

      <div className="container">
        <Header />

        <InputPanel
          customerProfile={customerProfile}
          onCustomerProfileChange={setCustomerProfile}
          category={category}
          onCategoryChange={setCategory}
          market={market}
          onMarketChange={setMarket}
          clientType={clientType}
          onClientTypeChange={setClientType}
          value={scenario}
          onChange={setScenario}
        />

        <ActionButtons loading={loading} canExport={canExport} onGenerate={generate} onClear={clear} onExportPdf={exportPdf} />

        {loading && (
          <StatusBanner
            tone="loading"
            title="Preparando sua reunião"
            message="Estamos organizando a lógica cenário -> OPC -> SPIN -> EPA -> Senoide com foco em valor, margem e adaptação ao contexto de Alimentos."
          />
        )}

        {!loading && error && <StatusBanner tone="error" title="Não foi possível gerar agora" message={error} />}
        {!loading && notice && <StatusBanner tone="success" title="Atualização" message={notice} />}
        {!loading && result && <PreparationCards result={result} />}

        <footer className="site-footer">
          © 2026 Paixão por Vendas, CVale e José Ricardo Noronha®
          <br />
          Inteligência aplicada à Venda de Valor em proteínas e alimentos | Todos os direitos reservados.
        </footer>
      </div>
    </main>
  );
};
